var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(false)?_c('div',{staticClass:"appearance"},[_c('h6',{on:{"click":_vm.togglePanel}},[_vm._v(_vm._s(_vm.onlineUsers.length))])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }